/**
 * Phase 99 (Plan 99-01) — TanStack Query hooks for the admin CSV import
 * surface.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchImportEntities, uploadImportCsv } from '../services/api/adminImports';
import { invalidateMany } from './queryUtils';

export function useImportEntities() {
  return useQuery({
    queryKey: ['admin-import-entities'],
    queryFn: fetchImportEntities,
  });
}

export function useUploadImportCsv() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ entity, file, dryRun }: { entity: string; file: File; dryRun: boolean }) =>
      uploadImportCsv(entity, file, dryRun),
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        // A committed bulk import can move users, projects, or assignments
        // depending on the entity — invalidate the lists most likely to be
        // stale immediately after a commit. `adminUsers` is the admin user
        // list's real query key (see useAdmin.ts); `users`/`projects` are
        // invalidated too since other admin surfaces read those keys.
        invalidateMany(queryClient, [['adminUsers'], ['users'], ['projects']]);
      }
    },
  });
}
